import { Stack, styled } from '@mui/material';

const Container = styled(Stack)<{ severity: 'error' | 'success' }>(({ severity, theme }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  width: '100%',
}));

export { Container };
